import React from 'react';
import BulmaModal from 'react-bulma-components/lib/components/modal';

import './style.scss';

export const ModalCard = ({ children, ...props }) => (
  <BulmaModal.Card {...props}>{children}</BulmaModal.Card>
);

const ModalCardHead = ({ children, ...props }) => (
  <BulmaModal.Card.Head {...props}>{children}</BulmaModal.Card.Head>
);

const ModalCardTitle = ({ children, ...props }) => (
  <BulmaModal.Card.Title {...props}>{children}</BulmaModal.Card.Title>
);

const ModalCardBody = ({ children, ...props }) => (
  <BulmaModal.Card.Body {...props}>{children}</BulmaModal.Card.Body>
);

const ModalCardFoot = ({ children, ...props }) => (
  <BulmaModal.Card.Foot {...props}>{children}</BulmaModal.Card.Foot>
);

ModalCard.Head = ModalCardHead;
ModalCard.Title = ModalCardTitle;
ModalCard.Body = ModalCardBody;
ModalCard.Foot = ModalCardFoot;

export default ModalCard;
